// extracted by mini-css-extract-plugin
export default {"overlay":"DefaultPageModal_overlay__qUZk9","modal":"DefaultPageModal_modal__1G7lH","closeButton":"DefaultPageModal_closeButton__QnXbO","body":"DefaultPageModal_body__xDrFD"};